import { connect } from 'react-redux';
import BookModule from '.';
import { isEmptyString } from '../../../../core/util/string';
import { AUTOSUGGEST_MINIMUM_INPUT_CHARS } from '../../../../config/index';
import { getSymptomsListUrl } from '../../../../core/dapi/symptom';
import { apiGetRuntime } from '../../../../core/dapi';
import {
  resetUserProfile,
  setBookingProfilePending,
  setLocationId,
} from '../../../../actions/newBooking';

const SUGGESTIONS = 'symptom-suggestions';

const mapStateToProps = (state: any) => ({
  currentlySelectedLocation: state.currentlySelectedLocation,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchSuggestions: (input: any) => {
    if (!isEmptyString(input) && input.length >= AUTOSUGGEST_MINIMUM_INPUT_CHARS) {
      const url = getSymptomsListUrl(input, 100);
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 5 arguments, but got 3.
      apiGetRuntime(dispatch, SUGGESTIONS, url);
    }
  },

  setBookingProfilePending: (value: boolean) => {
    if (value) {
      dispatch(setBookingProfilePending(true));
      dispatch(resetUserProfile());
    } else {
      dispatch(setBookingProfilePending(false));
    }
  },

  setNewBookingLocationId: (value: any) => dispatch(setLocationId(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookModule);
